import { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { URL_BACKEND } from "../../api/url";
import { elToast } from "../../functions/alertas";
import { Modal } from "antd";
import { InstruccionesExamen } from "../../components/InstruccionesExamen";

const useExamen = () => {

    const cookies = new Cookies();
    const pk_aspirante = cookies.get("pk_aspirante");
    const fk_carrera = cookies.get("fk_carrera");
    const nivel = cookies.get("nivel");

    const navigator = useNavigate();


    const [materias, setMaterias] = useState([]);
    const [inglesContestada, setInglesContestada] = useState(false);

    var pk_aspiranteLS = localStorage.getItem("pk_aspirante");


    const verificarCookie = () => {

        if ( pk_aspirante === undefined && fk_carrera === undefined) {

            alert("Para realizar el examen debes iniciar sesión.");
            navigator("/");
            return;


        } else {

            let d = new FormData()
            d.append('funcion', 'traerMaterias')
            // console.log(nivel);
            if ( nivel == 'MAE' ) {
                d.append('fk_carrera', 'maestría')
                // console.log('maestría');
            } else {
                d.append('fk_carrera', fk_carrera)
                // console.log(fk_carrera);
            }

            fetch( URL_BACKEND, {
                body: d,
                method: 'post'
            })
            .then( res => res.json() )
            .then( setMaterias )
            .catch( () => { elToast('Ocurrió un problema al mostrar las materias a contestar, vuelve a intentarlo.', "error"); } )

        }

        // to={"/examen/" + e.pk_materia}
    }


    const verificarInglesContestada = () => {

        let data = new FormData();
        data.append("funcion", "traerEstadoExamen");
        data.append("fk_aspirante", pk_aspirante);
        data.append("fk_materia", 4);

        fetch(URL_BACKEND, {
        body: data,
        method: "post",
        })
        .then((res) => res.json())
        .then((r) => {

        if(r.codigo == 1){

            setInglesContestada(true);

        }else{

            setInglesContestada(false);

        }

        })
        .catch(() => {
        elToast(
            "Ocurrió un problema al verificar las materias contestadas, por favor recarga la página.",
            "error"
        );
        });

    }


    const modalInstrucciones = () => {
        Modal.info({
        title: <h3>Instrucciones para el examen</h3>,
        content: <InstruccionesExamen />,
        okText: "He leido y estoy de acuerdo",
        onOk() {

            localStorage.setItem("pk_aspirante", pk_aspirante);

        },
        width: 800,
        style: { top: 65 },
        });
    };



    const enviarAmateria = (pk_materia) => {

        //validar la fecha de ingreso a la materia
        let d = new FormData();
        d.append("funcion", "validarFechaIngresoExamen");

        fetch(URL_BACKEND, {
            body: d,
            method: "post",
        })
        .then((res) => res.json())
        .then((r) => {

            // todo: borrar
            console.log("acceder");
            console.log(r);

            if (r.codigo == 1) { //la fecha sigue vigente

            //validar si el usuario ya habia entrado previamente al examen
            let data = new FormData();
            data.append("funcion", "traerEstadoExamen");
            data.append("fk_aspirante", pk_aspirante);
            data.append("fk_materia", pk_materia);

            fetch(URL_BACKEND, {
                method: "POST",
                body: data,
            })
            .then((res) => res.json())
            .then((r) => {

                if (r.codigo == 1) {

                    elToast("Ya has entrado y contestado este examen previamente, el acceso ha terminado.", "info3");

                } else {

                    //validar que primero se conteste la materia de Inglés

                    //si el pk_materia es igual a 4 se deja pasar porque es Inglés y se debe contestar primero

                    if (inglesContestada == false && pk_materia != 4) {

                        elToast("Primero debes responder Inglés.", "info2");

                    } else {

                        navigator("/examen/" + pk_materia);

                    }

                }

            })
            .catch(() => { elToast('Ocurrió un problema al verificar la fecha de ingreso a esta materia, vuelve a intentarlo.', "error"); });

            } else {

                elToast("La fecha vigente para realizar el examen ha terminado.", "info3");

            }

        })
        .catch(() => { elToast('Ocurrió un problema al verificar la fecha de ingreso a esta materia, vuelve a intentarlo.', "error"); });

    };



    useEffect(() => {

        verificarCookie();

        if (pk_aspirante != pk_aspiranteLS) {

            modalInstrucciones();

        }

        verificarInglesContestada();


        //si el aspirante se salió de una materia voluntaria o involuntariamente se verifica si contestó mínimo una pregunta para actualizar el estado de la materia a 1
        //si no hay respuestas el estado queda en 0

        let materiaContestada = localStorage.getItem("materiaContestada");

        // console.log(materiaContestada);

        if ( materiaContestada != null ) {

            let data = new FormData();
            data.append("funcion", "verificarParaActualizarEstadoExamen");
            data.append("pk_aspirante", pk_aspirante);
            data.append("id_materia", materiaContestada);

            fetch(URL_BACKEND, {
                body: data,
                method: "post",
            })
            .then((res) => res.json())
            .then((r) => {

                // console.log(r);

                if (r.codigo == 1 || r.codigo == 2) {

                    //eliminar variable materiaContestada para que, si se recarga la página, no se vuelva a ejecutar la función

                    //el codigo 2, aunque no sea una actualización, son aspectos de la materia que no necesitan volver a recargar página para verificarlos porque así quedarán a menos que se reinicie la materia

                    localStorage.removeItem("materiaContestada");

                    //cuando se ingrese a otra materia se volverá a crear con otra id

                } else if (r.codigo == 0) {

                    elToast(
                        "Ocurrió un problema al verificar la materia, por favor recarga la página.",
                        "error"
                    );

                    //al recargar la página se volverá a ejecutar la función con el id de la última materia a la cual se ingresó para reintentar verificarla correctamente

                }

            })
            .catch(() => {
                elToast("Ocurrió un problema al verificar su ingreso a la materia, por favor recarga la página.","error");
            });

        } //si es null, el aspirante aún no entra a alguna materia. No se hace nada

    }, []);



    return {
        materias,
        enviarAmateria
    }

}

export default useExamen;